import 'vite/modulepreload-polyfill'

import { setupVhListener } from '@/lib/vh'
import { setupLenis } from '@/lib/lenis'
import { setupSwup } from '@/lib/swup'
import { setupSwupHooks } from '@/lib/swup-hooks'
import { setupAlpine } from '@/lib/alpine/init'
import { handleHashScroll, checkForHashLinks } from '@/lib/hash-scroll'
import { log } from '@/utils/log'

window.addEventListener('DOMContentLoaded', () => {
	setupVhListener()
	setupLenis()
	setupSwup()
	setupSwupHooks()
	setupAlpine()
	handleHashScroll()
	checkForHashLinks()

	log('%cDevelopment by Buena Suerte LLC https://buena-suerte.studio', 'font-weight: bold')
})
